import VesselPostProcessingService from './VesselPostProcessingService';

class SpecialisedVesselPostProcessingService extends VesselPostProcessingService {
    updateOwnerIfRequired(newValue, data, variables, tabType) {
        if (!newValue || newValue?.shouldUpdateOwner) {
            const owner = this.getNewOwnerObject(newValue);
            data['owner'] = owner;
            variables[tabType]['owner'] = owner;
        }
    }

    getNewOwnerObject(newValue) {
        return newValue && newValue.bestOperator
            ? { id: null, name: newValue.bestOperator.toUpperCase() }
            : null;
    }

    getOldOwner(props) {
        return props.data.owner ? props.data.owner.name.toUpperCase() : null;
    }

    getNewOwner(vessel) {
        return vessel.bestOperator ? vessel.bestOperator.toUpperCase() : null;
    }

    getOldOwnerName(props) {
        return this.getOldOwner(props);
    }

    getNewOwnerName(vessel) {
        return this.getNewOwner(vessel);
    }
}

export default SpecialisedVesselPostProcessingService;
